import React from "react";
import { useFormContext } from "react-hook-form";
import { CreateBillDto } from "../model/bill/dto/CreateBillDto";

export const CreateEditModalFooter: React.FC = () => {
  const { register, watch } = useFormContext<CreateBillDto>();

  const billDetails = watch("billDetails");

  const total = billDetails.reduce(
    (prev, curr) => prev + Number(curr.qty) * Number(curr.unitPrice),
    0
  );

  return (
    <div className="d-flex gap-2 fs-5">
      <div className="d-flex flex-column flex-1">
        <p>Thank you for your order</p>
      </div>

      <div className="d-flex border border-1 border-black border-end-0 flex-grow-1">
        <div
          className="d-flex flex-column p-2 gap-2 border-end border-end-1 border-black"
          style={{ flex: 5 }}
        >
          <p className="text-danger">TERMS & CONDITIONS</p>
          <div
            className="d-flex flex-column pb-2 gap-2 border-bottom border-bottom-3 border-black"
            style={{ flex: 5 }}
          >
            <p>RECEIVED BY:</p>

            <textarea
              placeholder="Received by information..."
              {...register("receivedBy")}
            />
          </div>
        </div>

        <div
          className="p-2 border-start border-start-1 border-black border-end border-end-1"
          style={{ flex: 2 }}
        >
          <p>SUBTOTAL:</p>
          <p>GST:</p>
          <p>PST:</p>
          <p>GRAND TOTAL:</p>
        </div>

        <div
          className="d-flex justify-content-center align-items-center p-2"
          style={{ flex: 2 }}
        >
          <p className="fs-3 fw-bold">{total}$</p>
        </div>
      </div>
    </div>
  );
};
